/**
 * Build SHA pill, public-site variant.
 *
 * Same rationale as the dashboard's VersionFooter (see that file's
 * header). Inline pill rendered inside the existing site footer,
 * not a separate fixed element — the public site already has a
 * full-width footer with site-info text, no need for a corner
 * floating widget.
 */
const SHA: string =
  ((import.meta as unknown as { env?: { VITE_VERCEL_GIT_COMMIT_SHA?: string } }).env
    ?.VITE_VERCEL_GIT_COMMIT_SHA as string | undefined) ?? "dev";

const SHORT = SHA === "dev" ? "dev" : SHA.slice(0, 7);
// Source repo is private — no public commit page. Show the build SHA
// as plain text (no link) rather than a 404ing GitHub URL.
const COMMIT_URL: string | null = null;

export function VersionFooter() {
  return (
    <span className="vf-pill" aria-label={`Build ${SHORT}`}>
      build{" "}
      {COMMIT_URL ? (
        <a href={COMMIT_URL} target="_blank" rel="noopener noreferrer">
          <code>{SHORT}</code>
        </a>
      ) : (
        <code>{SHORT}</code>
      )}
      <style>{`
        .vf-pill { font-family: var(--at-font-mono, monospace); font-size: 10px;
          letter-spacing: 0.06em; color: var(--at-muted); }
        .vf-pill code { color: var(--at-fg-dim); background: var(--at-bg);
          padding: 1px 5px; border-radius: 4px;
          border: 1px solid var(--at-hairline); }
        .vf-pill a { color: inherit; text-decoration: none; }
        .vf-pill a:hover code { color: var(--at-fg); }
      `}</style>
    </span>
  );
}
